import React from 'react';
import { Line } from 'react-chartjs-2';

export interface ChartSeries {
  label: string;
  data: number[];
  borderColor: string;
  fill: boolean;
}

export interface AssociateScanChartProps {
  labels: string[];
  datasets: ChartSeries[];
}

const chartOptions = {
  maintainAspectRatio: false,
  legend: { display: true, position: 'bottom' as const },
  scales: {
    xAxes: [{ gridLines: { drawOnChartArea: false } }],
    yAxes: [{ gridLines: { drawOnChartArea: false }, ticks: { autoSkip: true, maxTicksLimit: 5 } }],
  },
};

/**
 * AssociateScanChart — presentational scan-rate line chart (React + Meridian feature,
 * react-chartjs-2 as in v1). Pure: `labels` + `datasets` in. The view computes the series.
 */
const AssociateScanChart: React.FC<AssociateScanChartProps> = ({ labels, datasets }) => (
  <Line data={{ labels, datasets }} options={chartOptions} />
);

export default AssociateScanChart;
